<template>
  <div class="count_wrapper">
<!--    <h3 class="count_title" :style="`color:${labelColor}`">免费报名，观展有礼</h3>-->
    <div class="count_continer">
      <span :style="`color:${labelColor}`">活动倒计时：</span>
      <b class="count_span" :style="`color:${labelColor}`">{{ count_day }}</b><span :style="`color:${labelColor}`">天</span>
      <b class="count_span" :style="`color:${labelColor}`">{{ count_hour }}</b><span :style="`color:${labelColor}`">时</span>
      <b class="count_span" :style="`color:${labelColor}`">{{ count_minute }}</b><span :style="`color:${labelColor}`">分</span>
      <b class="count_span" :style="`color:${labelColor}`">{{ count_second }}</b><span :style="`color:${labelColor}`">秒</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "countDown",
  props: {
    labelColor: {type: String},
    stime: {type: Number}
  },
  data() {
    return {
      count_day: 0,
      count_hour: 0,
      count_minute: 0,
      count_second: 0,
    };
  },
  mounted() {
    this.get_time();
  },
  methods: {
    get_time() {
      let date = Math.floor(Date.now() / 1000);
      //时间差
      let count_time = this.stime - date;

      //定义变量 d,h,m,s保存倒计时的时间
      if (count_time >= 0) {
        this.count_day = Math.floor(count_time / 60 / 60 / 24);
        this.count_hour = Math.floor((count_time / 60 / 60) % 24);
        this.count_minute = Math.floor((count_time / 60) % 60);
        this.count_second = Math.floor(count_time % 60);
      }
      //递归每秒调用countTime方法，显示动态时间效果
      setTimeout(this.get_time, 1000);
    },
  },
};
</script>

<style scoped lang="less">
.count_wrapper {
  width: 100%;
}
.count_continer {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  padding-top: 10px;
}
.count_title {
  width: 100%;
  text-align: center;
  line-height: 25px;
  padding-top: 20px;
  /*color: red;*/
}
.count_span {
  display: inline-block;
  height: 20px;
  line-height: 20px;
  text-align: center;
  margin: 0 5px;
  font-weight: bold;
}
</style>
